import './WidgetConfigurator.css';

import { Box } from '@mui/material';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import { useState, useEffect } from 'react';

const WidgetConfigurator = ({ dto, widgetTemplate, onWidgetConfigurationChange }) => {
    const { t } = useB2BTranslation('b2b-reporting');
    const [ConfiguratorComponent, setConfiguratorComponent] = useState(null);
    const [currentTemplate, setCurrentTemplate] = useState(null);

    useEffect(() => {
        const loadComponent = async () => {
            if (widgetTemplate?.acronym && widgetTemplate !== currentTemplate) {
                setCurrentTemplate(widgetTemplate);
                try {
                    const component = await import(`./${widgetTemplate.acronym}_Configurator.js`);
                    setConfiguratorComponent(() => component.default);
                } catch (error) {
                    setConfiguratorComponent(null);
                    // Optionally log or handle error
                }
            }
        };
        if (widgetTemplate && widgetTemplate !== currentTemplate) {
            loadComponent();
        }
    }, [widgetTemplate, currentTemplate]);

    const handleWidgetConfigurationChange = (newConfig) => {
        // console.log('New Widget Configuration:', newConfig);
        onWidgetConfigurationChange && onWidgetConfigurationChange(newConfig);
    };

    if (!ConfiguratorComponent) {
        return (
            <Box>
                {t('Loading...')}
            </Box>
        );
    }

    return (
        <ConfiguratorComponent
            dto={dto}
            widgetTemplate={widgetTemplate}
            onWidgetConfigurationChange={handleWidgetConfigurationChange}
        />
    );
}

export default WidgetConfigurator;